// extracted by mini-css-extract-plugin
export default {"icon":"CopySettingsButton_icon__TWAdf","placeHolderShimmer":"CopySettingsButton_placeHolderShimmer__P7AIa"};